import React, { useContext, useEffect, useState } from 'react';
import "../CreateWorkOrder/workorder.css";
import Application from '../../../StateContext/Application.js';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages.js';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const EditWorkOrder = () => {
    const nav = useNavigate();
    const urlLocation = useLocation();
    const id = urlLocation.state?.id;

    const operation = useContext(Application);
    const { WorkOrderCreation, GetBudgetHeadInfo, GetProjectInfo } = operation;

    const [HeadInfo, setHeadInfo] = useState([]);
    const [Taluka, setTaluka] = useState([]);
    const [switchshow, setSwitchShow] = useState(0);
    const [loading, setLoading] = useState(false);
    const [Contractor, setContractor] = useState([]);

    const [data, setData] = useState({
        WorkID: id,
        HeadCode: "",
        ProposalYear: "",
        talulka: '',
        GrID: '',
        ProposalId: '',
        PanNo: '',
        ContractorName: "",
        WorkName: null,
        WorkOrderNo: null,
        WorkOrderDate: null,
        WorkEndDate: null,
        ProposalCost: "0",
        RemainingProposalCost: "0",
        ApprovedWorkAmount: "0",
        PaidAmount: "0",
        RemainingAmount: "0",
        fillingForm: "second",
        OriginalRemainingAmount: "0",
        OriginalPaidAmount: "0",
        TechnicalSanctionUID: "",
    });

    const HandleChangeData = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);
    //     try {
    //         const formData = new FormData();
    //         for (const key in data) {
    //             formData.append(key, data[key]);
    //         }
    //         let GRCopy = document.getElementById("GRCopy").files;

    //         if (GRCopy && GRCopy.length <= 0) {
    //             return alert("Not Inserted Supporting File !!!!");
    //         };

    //         formData.append("GRCopy", GRCopy[0]);
    //         formData.append("type", "Edit");

    //         console.log("Data i will send to beakcne d:: ", data);

    //         let result = await AdministrativeApprovalCreation(formData);
    //         console.log(result);
    //         alert(result);
    //         window.location.reload();
    //         nav(-1);
    //     } catch (err) {
    //         console.log(err);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        let shouldSubmit = window.confirm("Are you Sure ??");

        if (shouldSubmit) {
            const formData = new FormData();
            setLoading(true);
            try {
                for (const key in data) {
                    formData.append(key, data[key]);
                }
                formData.append("ActionType", "EditWorkOrder");
                let result = await WorkOrderCreation(formData);
                console.log(result);
                const { status, message } = result;

                if (status) {
                    alert(message)
                    nav(-1);
                    setLoading(false);
                }
                else {
                    alert(message);
                    setLoading(false);
                }
            } catch (error) {
                console.log(error)
                setLoading(false);
            }
            finally {
                setLoading(false);
            }
        }
        else {
            alert("Work Order Edit Operation Cancel !!!");
            setLoading(false);
        }



    };


    const FetchData = async () => {
        setLoading(true);
        try {
            let res1 = await GetProjectInfo('null', "Contractor");
            setContractor(res1);
        }
        catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        FetchData();
    }, []);


    const FetchedIntitialData = async () => {
        try {
            let res = await GetBudgetHeadInfo(id, "GetSpecificWorkdetailOrderInfo");
            console.log("Data i get from Bakcend :: ", res);
            let WorkInfo = res[0];

            const { HeadCode, ProposalYear, GrID, talulka, ProposalID, TechnicalUID, ProjectCost, PanNo, ContractorName, WorkName, WorkOrderDate, WorkEndDate, ApprovedWorkAmount, PaidAmount, RemainingAmount, WorkOrderNo } = WorkInfo;

            const rawStartDate = WorkOrderDate;
            const rawEndDate = WorkEndDate;

            const formattedStartDate = rawStartDate ? new Date(rawStartDate).toISOString().slice(0, 16) : "";
            const formattedEndDate = rawEndDate ? new Date(rawEndDate).toISOString().slice(0, 16) : "";


            setData({
                ...data,
                WorkID: id,
                HeadCode: HeadCode,
                ProposalYear: ProposalYear,
                talulka: talulka,
                GrID: GrID,
                ProposalId: ProposalID,
                PanNo: PanNo,
                ContractorName: ContractorName,
                WorkName: WorkName,
                WorkOrderNo: WorkOrderNo,
                WorkOrderDate: formattedStartDate,
                WorkEndDate: formattedEndDate,
                ApprovedWorkAmount: ApprovedWorkAmount,
                PaidAmount: PaidAmount,
                RemainingAmount: RemainingAmount,
                ProposalCost: ProjectCost
            });

        }
        catch (err) {
            console.log(err);
        }
    }


    useEffect(() => {
        FetchedIntitialData();
    }, [id]);

    return (
        <>
            {
                data &&
                <div style={{ height: '91vh', overflowY: 'auto' }}>
                    <div className="col-12" style={{ backgroundColor: "#EFF3F8", padding: '2rem 0px 5px 0px' }}>

                        <div className="col-12 m-auto my-5 budgetContainer">
                            <div className="m-auto budgetElement">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                                    <div>
                                        <h5 className=' bg-light'><img src={ProposalCreation32} /> Edit Work Order Detail</h5>
                                    </div>
                                    <div>
                                        <img src={Back32} onClick={() => nav(-1)} />
                                    </div>
                                </div>
                                <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>Note : Fields marked with * are mandatory</p>

                                {loading && (
                                    <div
                                        style={{
                                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                            display: 'flex', justifyContent: 'center', alignItems: 'center'
                                        }}>
                                        <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                                        <style>
                                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                        </style>
                                    </div>
                                )}

                                <div className="budgetElement2">
                                    <form action="">

                                        {/* <div className="col-12 elements">
                                                           <div className="row">
                                                               <div className="col-5">
                                                                   <label>Work Order UID</label>
                                                               </div>
                                                               <div className="col-7">
                                                                   <input type="text" placeholder='Enter Constituency Name' className='form-control py-2'
                                                                       value={data.WorkID} disabled />
                                                               </div>
                                                           </div>
                                                       </div> */}

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>HeadCode</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter Constituency Name' className='form-control py-2'
                                                        value={data.HeadCode} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label> Proposal Year</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter Constituency Name' className='form-control py-2'
                                                        value={data.ProposalYear} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>GR UID</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter Constituency Name' className='form-control py-2'
                                                        value={data.GrID} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>Proposal Work Name</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter Constituency Name' className='form-control py-2'
                                                        value={data.ProposalId} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>Techincal Sanction RDD UID</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter Constituency Name' className='form-control py-2'
                                                        value={data.TechnicalSanctionUID} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>Zilla Parishad</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" className='form-control py-2'
                                                        value={data.talulka} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>PAN No.</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter PAN Number' className='form-control py-2' name='PanNo' value={data.PanNo} onChange={(e) => {

                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, '');

                                                        const upperValue = value.toUpperCase();
                                                        setData({ ...data, PanNo: upperValue });
                                                    }}
                                                        maxLength={10} />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>Vendor Name</label>
                                                </div>
                                                <div className="col-7">
                                                    <select name="ContractorName" value={data.ContractorName} id="" className='form-select py-2' onChange={(e) => { e.preventDefault(); setData({ ...data, ContractorName: e.target.value }); }} style={{ color: data.Bidder_CompanyName === "" ? "#999" : "#333", fontWeight: "500", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: "#fff" }}>
                                                        < option value="null">Choose Vendor</option>
                                                        {Contractor && Contractor.map((val, index) => {
                                                            return (
                                                                <option key={index} value={val.Bidder_CompanyName}>{val.Bidder_CompanyName}</option>
                                                            )
                                                        })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>Work Name</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" className='form-control py-2'
                                                        value={data.WorkName} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>Work Order No</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter Work Order Number' className='form-control py-2' name='WorkOrderNo' value={data.WorkOrderNo} onChange={HandleChangeData} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5  ">
                                                    <label  >Work Order Start Date</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="datetime-local" placeholder='Enter Work Order Date' className='form-control py-2' value={data.WorkOrderDate} name='WorkOrderDate' onChange={HandleChangeData} max={new Date().toISOString().slice(0, 16)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5  ">
                                                    <label >Work Order End Date</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="datetime-local"
                                                        placeholder='Enter Work Order Date' className='form-control py-2'
                                                        value={data.WorkEndDate} name='WorkEndDate' onChange={HandleChangeData} min={new Date().toISOString().slice(0, 16)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>Proposal Work Amount</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="number" placeholder='Enter Approved Work Amount' className='form-control py-2' name='ApprovedWorkAmount' value={data.ProposalCost} onChange={HandleChangeData} disabled />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>Approved Work Amount</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="number" placeholder='Enter Approved Work Amount' className='form-control py-2' name='ApprovedWorkAmount' value={data.ApprovedWorkAmount} onChange={HandleChangeData} disabled />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>Paid Amount</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="number" placeholder='Enter Paid Amount' className='form-control py-2' name='PaidAmount' value={data.PaidAmount} onChange={HandleChangeData} disabled />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5 my-auto ">
                                                    <label className='my-auto'>Remaining Amount</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="number" placeholder='Enter Remaining Amount' className='form-control py-2' name='RemainingAmount'
                                                        value={data.RemainingAmount}
                                                        onChange={HandleChangeData} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 ms-auto my-4">
                                            <div className="row">
                                                <div className="col-5"></div>
                                                <div className="col-7">
                                                    <div className="col-12" style={{ display: 'flex', gap: '10px' }}>
                                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={handleSubmit}><img src={submit} style={{ width: '15px' }} /> Edit</button>
                                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => nav(-1)}> <img src={Cancel32} style={{ width: '17px' }} />Back</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default EditWorkOrder;